/*! @azure/msal-browser v2.31.0 2022-11-07 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.31.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@azure/msal-browser/dist/packageMetadata.js
// module id = 51
// module chunks = 0